<template>
    <div class="row">
        <div class="col-12 mb-4">
            <router-link :to="'/school/classroom/' + $route.params.classroom">
                <base-button type="info" class="left">
                    <font-awesome-icon :icon="['fal','chevron-left']" size="lg"
                                       style="margin-right: 1em;"></font-awesome-icon>
                    Back to classroom
                </base-button>
            </router-link>
        </div>
        <div class="col-sm-12 col-md-6">
            <card>
                <div slot="header">
                    <h3>Statistics</h3>
                    <table v-if="loading.statistics === false"
                           class="table table-striped">
                        <tbody>
                        <tr>
                            <td>Past 24 hours</td>
                            <td><span>{{ statistics.past_24_hours.calls }} Calls</span> - <span>Duration: {{
                                moment.duration(Number.parseInt(statistics.past_24_hours.duration),'seconds').format("h [hrs], m [min]") }}
                            </span></td>
                        </tr>
                        <tr>
                            <td>Past 7 days</td>
                            <td><span>{{ statistics.past_7_days.calls }} Calls</span> - <span>Duration: {{
                                moment.duration(Number.parseInt(statistics.past_7_days.duration),'seconds').format("h [hrs], m [min]") }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Past month</td>
                            <td><span>{{ statistics.past_month.calls }} Calls</span> - <span>Duration: {{
                                moment.duration(Number.parseInt(statistics.past_month.duration),'seconds').format("h [hrs], m [min]") }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Daily average</td>
                            <td>{{ statistics.daily_average }} Calls</td>
                        </tr>
                        <tr>
                            <td>Weekly average</td>
                            <td>{{ statistics.weekly_average }} Calls</td>
                        </tr>
                        </tbody>
                    </table>
                    <hr>
                    <h4>Calls past 30 days</h4>
                    <line-chart
                        v-if="loading.statistics === false"
                        :chart-data="chartData"
                        :gradient-colors="[
      'rgba(76, 211, 150, 0.1)',
      'rgba(53, 183, 125, 0)',
      'rgba(119,52,169,0)'
    ]"
                        :gradient-stops="[1, 0.4, 0]"
                        :height="250"
                        :extra-options="chartOptions"
                    >
                    </line-chart>


                </div>
            </card>
        </div>
        <div class="col-sm-12 col-md-6">
            <card>
                <div slot="header">
                    <h3>This is the history for {{ student.name || '...' }} with PIN: {{ student.pin || '...'}}</h3>
                </div>
                <el-table v-loading="loading.history" :data="history"
                          :default-sort="{prop: 'datetime', order: 'descending'}">
                    <el-table-column
                        min-width="120"
                        label="Date"
                        property="datetime">
                        <template slot-scope="scope">
                            {{ moment(scope.row.datetime).format('LLL') }}
                        </template>

                    </el-table-column>
                    <el-table-column
                        min-width="120"
                        label="Caller ID"
                        property="origin_number">
                        <template slot-scope="scope">
                            <span> {{ scope.row.origin_number }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="80"
                        label="Call time"
                        property="duration">
                        <template slot-scope="scope">
                            <span> {{ moment.duration(scope.row.duration,'seconds').format("h [hrs], m [min]") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="80"
                        label="Actions"
                        class-name="text-right"
                    >
                        <div slot-scope="{row, $index  }" class="text-right table-actions">
                            <el-tooltip
                                content="Show the flow of the call this student made."
                                effect="light"
                                :open-delay="300"
                                placement="top"
                            >
                                <base-button type="primary" size="sm" class="right" @click="viewCallFlow(row)">
                                    Call map
                                </base-button>
                            </el-tooltip>
                        </div>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[5,10, 25, 50, 100]"
                    :page-size="perPage"
                    :page-count="totalPages"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </card>
            <call-flow-modal v-if="showCallFlowModal" :call_id="selectedCall.unique_id" :student_id="student.id"
                             @close="showCallFlowModal = false"></call-flow-modal>
        </div>


    </div>

</template>
<script>
    import axios from "axios";
    import CallFlowModal from "./CallFlowModal";
    import LineChart from '../../../../src/components/Charts/LineChart';

    export default {
        name: 'call-history',
        components: {
            CallFlowModal,
            LineChart
        },
        data() {
            return {
                student: null,
                classroom: null,
                history: null,
                currentPage: 1,
                perPage: 10,
                totalPages: 1,
                total: 1,
                loading: {
                    classroom: true,
                    statistics: true,
                    history: true
                },
                showCallFlowModal: false,
                selectedCall: null,
                chartOptions: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    responsive: true,
                    tooltips: {
                        backgroundColor: '#f5f5f5',
                        titleFontColor: '#333',
                        bodyFontColor: '#666',
                        bodySpacing: 4,
                        xPadding: 12,
                        mode: 'nearest',
                        intersect: 0,
                        position: 'nearest'
                    },
                    scales: {
                        yAxes: [
                            {
                                barPercentage: 20,
                                gridLines: {
                                    drawBorder: false,
                                    color: 'rgba(29,140,248,0.0)',
                                    zeroLineColor: 'transparent'
                                },
                                ticks: {
                                    padding: 20,
                                    fontColor: '#9e9e9e'
                                }
                            }
                        ],

                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: 'rgba(29,140,248,0.1)',
                                    zeroLineColor: 'transparent'
                                },
                                ticks: {
                                    autoSkip: true,
                                    maxTicksLimit: 5,
                                    maxRotation: 0,
                                    padding: 20,
                                    fontColor: '#9e9e9e'
                                }
                            }
                        ]
                    }
                }
            }
        },
        computed: {
            chartData() {
                return {
                    labels: this.statistics.last_month.labels,
                    datasets: [
                        {
                            label: 'Calls',
                            fill: true,
                            borderColor: '#42b883',
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: '#42b883',
                            pointBorderColor: 'rgba(255,255,255,0)',
                            pointHoverBackgroundColor: '#be55ed',
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: this.statistics.last_month.data
                        }
                    ]
                }
            },
        },
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }

            this.loadClassroom();
            this.loadStudent();
            this.loadHistory();
            this.loadStatistics();

        },

        methods: {
            loadClassroom() {
                this.loading.classroom = true;
                return axios({
                    url: this.baseAPIURL + 'classroom/' + this.$route.params.classroom, method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.classroom = resp.data.data;
                    this.classroom.allow_login = Boolean(this.classroom.allow_login);
                }).finally(() => {
                    this.loading.classroom = false;
                });
            },
            loadStudent() {
                this.loading.student = true;
                return axios({
                    url: this.baseAPIURL + 'student/' + this.$route.params.student, method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.student = resp.data.data;

                }).finally(() => {
                    this.loading.student = false;
                });
            },
            loadHistory() {
                this.$set(this.loading, 'history', true);
                return axios.get(this.baseAPIURL + 'student/' + this.$route.params.student + '/call/history/all', {
                    params: {
                        page: this.currentPage,
                        perPage: this.perPage,
                    },
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.history = resp.data.data;
                    this.total = Number.parseInt(resp.data.meta.total);
                    this.perPage = Number.parseInt(resp.data.meta.per_page);
                    this.currentPage = Number.parseInt(resp.data.meta.current_page);
                    this.totalPages = Number.parseInt(resp.data.meta.last_page);
                }).finally(() => {
                    this.$set(this.loading, 'history', false);
                });
            },
            loadStatistics() {
                this.$set(this.loading, 'statistics', true);
                return axios.get(this.baseAPIURL + 'student/' + this.$route.params.student + '/call/statistics')
                    .then(resp => {
                        this.statistics = resp.data.data;
                    }).finally(() => {
                        this.$set(this.loading, 'statistics', false);
                    });
            },
            handleSizeChange(val) {
                this.perPage = Number.parseInt(val);
                console.log(`${val} items per page`);
                this.loadHistory();
            },
            handleCurrentChange(val) {
                this.currentPage = Number.parseInt(val);
                console.log(`current page: ${val}`);
                this.loadHistory();
            },
            viewCallFlow(row) {
                this.selectedCall = row;
                this.showCallFlowModal = true;
            }
        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    }
</script>
